import { ClarionCard } from '@clarion/ClarionCard';
import { ClarionNonIdealState, NonIdealStateProps } from '@clarion/ClarionNonIdealState';
import { H1 } from '@clarion/Typography';
import { HTMLAttributes } from 'react';
import recapLogo from '../shared/recapLogo.svg';
import supportLinks from '../shared/supportLinks';

type NonIdealPageProps = HTMLAttributes<HTMLDivElement> &
  NonIdealStateProps & { as?: 'main' | 'section' };

export default function NonIdealPage({ as: Wrapper = 'main', ...props }: NonIdealPageProps) {
  return (
    <Wrapper className="min-h-screen flex flex-col items-center justify-center p-4 bg-gray-50 dark:bg-gray-900">
      {props.title && <title>{props.title}</title>}
      <ClarionCard className="max-w-md w-full py-8">
        <div className="flex flex-col items-center mb-2 gap-4 text-balance">
          <ClarionNonIdealState TitleElement={H1Wrapper} {...props} />
        </div>
      </ClarionCard>
      <a
        href={supportLinks.about}
        target="_blank"
        className="flex items-center gap-2 mt-6"
        rel="noreferrer"
      >
        <img src={recapLogo} alt="" className="h-6" />
        <span className="text-sm opacity-75">Recap Innovations</span>
      </a>
    </Wrapper>
  );
}

function H1Wrapper(props: HTMLAttributes<HTMLHeadingElement>) {
  return <H1 {...props} className="mb-4" />;
}
